// extracted by mini-css-extract-plugin
export var shake = "_1j-0";